// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"studentLesson_wrapper__13Vh8","footerSidebar":"studentLesson_footerSidebar__3yIoN","returnCourseContainer":"studentLesson_returnCourseContainer__3pF_f"};